import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Chip, Stack } from "@mui/material";
import EqualizerRoundedIcon from "@mui/icons-material/EqualizerRounded";
import { StreamState } from "@service/companion-streaming.service";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

const StateIcon: FC = () => {
  const { t } = useTranslation();
  const { processing, ready, streamState } = useSelector(
    (state: RootState) => state.avatar,
  );

  const state = useMemo(() => {
    if (!streamState) {
      return processing ? "responding" : "speaking";
    }
    if (streamState === StreamState.Processing) {
      return "thinking";
    }
    if (streamState === StreamState.Streaming) {
      return processing ? "responding" : "thinking";
    }
    return processing ? "responding" : "speaking";
  }, [streamState, processing]);

  const text = useMemo(() => {
    return t(`companion.state.${state}`);
  }, [state, t]);

  const icon = useMemo(() => {
    switch (state) {
      case "speaking":
        return <EqualizerRoundedIcon color="success" />;
      case "thinking":
        return <MoreHorizIcon color="warning" />;
      case "responding":
      default:
        return null;
    }
  }, [state]);

  if (!ready) {
    return null;
  }

  return (
    <Chip
      id='avatar-state-chip'
      variant="filled"
      sx={{ backgroundColor: "#000", opacity: 0.8, color: "#fff" }}
      label={
        <Stack flexDirection="row" gap="8px" alignItems="center">
          {text}
          {icon}
        </Stack>
      }
    />
  );
};

export default StateIcon;
